import { delay } from 'redux-saga/effects';

export default function delayTwoSeconds() {
  return delay(2000);
}
